import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import {
  TaxExtensionProgressionActions,
  TaxExtensionProgressionMenu,
} from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions'
import { CollapseSecondaryActionsContext } from '@/features/jobs/details/components/JobProgressionCard/collapse-secondary-actions-context'

export interface TaxExtensionProgressionActionsContainerProps {
  vm: JobProgressionViewModel
  isSecondary?: boolean
}

export const TaxExtensionProgressionActionsContainer = observer(
  function TaxExtensionProgressionActionsContainer({
    vm,
    isSecondary,
  }: TaxExtensionProgressionActionsContainerProps) {
    const collapseSecondary = useContext(CollapseSecondaryActionsContext)
    const Actions =
      isSecondary && collapseSecondary
        ? TaxExtensionProgressionMenu
        : TaxExtensionProgressionActions

    return (
      <Actions
        isSecondary={isSecondary}
        isPersonalExtensionAvailable={vm.isPersonalExtensionAvailable}
        isBusinessExtensionAvailable={vm.isBusinessExtensionAvailable}
        isOutsourcingExtensionAvailable={vm.isOutsourcingExtensionAvailable}
        onBeginPersonalExtension={vm.answerJobPersonalExtensionInProgress}
        onBeginBusinessExtension={vm.answerJobBusinessExtensionInProgress}
        onPlaceJobOnExtension={vm.answerJobOutsourcingExtensionInProgress}
      />
    )
  },
)
